import type { TI_NumberData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTINumberData: Omit<TI_NumberData, 'selectedVariable'> = {
  title: 'Default Number Title'
};
